import { gql } from '@apollo/client';

const GET_PARTNER_CONFIGURATION = gql`
  query getApplicationConfiguration(
    $pid: String!
    $affiliateId: String!
    $requestId: String!
    $overrideChannelSource: String
  ) {
    getApplicationConfiguration(
      pid: $pid
      affiliateId: $affiliateId
      requestId: $requestId
      overrideChannelSource: $overrideChannelSource
    ) {
      partnerName
      companyCode
      language
      pax
      pnr
      partnerShortName
      partnerType
      enableCanvasExperimentalTheme
      labsPartnerType
      partnerWebsite
      usesLanguageSelector
      usesCurrencySelector
      isPointsPlusPayEnabled
      extraSeatDisclaimerPaymentPageDisplay
      payment {
        cvv
        cardTypes {
          name
          code
        }
        paymentMode {
          tokenless {
            enabled
          }
        }
        includeCardByCurrency {
          card
          currencies
        }
      }
      fccSettings {
        enabled
      }
      billingSettings {
        addressEnabled
        states
        countryCode
      }
      productsSettings {
        extraSeatSettings {
          splitSeating
        }
        onboardSettings {
          enabled
          channelSourcesAnyOf
        }
        checkinSettings {
          url
        }
      }
      currency
      defaultCurrency
      defaultLanguage
      supportedLanguages
      supportedCurrencies
      apiGateway

      taxDisplay
      termsAndConditions
      termsAndConditionsExtraSeat
      currencyFormatSettings {
        stringFormat
        grouping
        fractionDigits
        currencySpecificFormats {
          stringFormat
          currencyCode
          grouping
          languageSpecificFormats {
            language
            grouping
            stringFormat
          }
        }
      }
      requestProfiles {
        apiKey
        channelSource
        profileName
      }
      crossAirline {
        ampEnabled
      }
      up {
        isPointPaymentsDisabled
        ampVersion
        componentConfigs {
          plusgradeFooter {
            displayFooter
            faqUrl
          }
          eligibilityWidget {
            showPrivacyPolicyCheckbox
          }
        }
        pageConfigs {
          coreShoppingExperiencePage {
            disableReviewPriceBreakdown
            enableMoreAboutSection
            disableCurrentExperienceCard
            upgradeTypeModal {
              upgradeType
              enabled
            }
          }
          offersPage {
            boostMyBid {
              incrementPercentage
            }
          }
        }
        currency {
          global {
            stringFormat
            groupingSeparator
            decimalSeparator
            fractionDigits
          }
          pointsSpecific {
            stringFormat
            groupingSeparator
            decimalSeparator
            fractionDigits
          }
          currencySpecific {
            currencyCode
            stringFormat
            groupingSeparator
            decimalSeparator
            fractionDigits
          }
        }
      }
      canvas {
        bidCard {
          hidePlaceButton
        }
        offersPage {
          disableGetPartialExperience
          splitConfirmationNumber
          howItWorksTemplate {
            sections {
              title
              steps
            }
          }
        }
        paymentPage {
          disclaimerWithNoCheckbox
          showSecondPaymentCheckBox {
            enabled
            channelSourcesAnyOf
          }
          binFundingSourceCheck {
            enabled
          }
        }
        confirmationPage {
          excludedViewOffersChannelSources
        }
        loyalty {
          enabled
          paymentType
          pointsSSOGatewayUrl
        }
        hero {
          displayPassengerName
          helpAsDropdown
          helpDefaultExpanded
        }
        partnerTagManager {
          enabled
          loadedEvent
          url
        }
        marketingPage {
          lookupMode
        }
      }
      affiliatePartners {
        pid
        partnerName
        enabled
        singleAirLandingPageHeroImage
        logoImage
        eligibilityWidgetApiKey
      }
      seatShop {
        enabled
        channelSources
      }
    }
  }
`;
export default GET_PARTNER_CONFIGURATION;
